<template>
    <div>
        <h2 style="text-align: center;">清除设备数据</h2>
        <p>请用摄像头对准设备的二维码，当视频中的二维码周围出现红色方框表示识别成功，识别的设备序列号将显示在下方的列表中.</p>
        <div id="loadingMessage" v-show="loadingMessageText" @click="startVideoStream">{{ loadingMessageText }}</div>
        <canvas id="canvas" hidden></canvas>
        <div id="output" v-show="outputVisiable">
            <div id="outputMessage" v-if="!serialCode">未识别到二维码,请打开手机闪光灯对准二维码并调整二维码在图片中的位置.</div>
            <div v-if="serialCode"><b>Data:</b> <span>{{ serialCode }}</span></div>
        </div>
        <div id="container">
            <div v-for="(item, index) in this.devSets" :key="index">{{ item }}</div>
        </div>
        
        <button id="resetDevice" @click="handleResetDevice" style="width: 30%;height: 50px;color: red; display: block; margin: 0 auto;">清除设备的数据</button>
    </div>
</template>

<script>
import jsQR from '@/js/jsQR';
import {getCookiesToken} from '../api';

export default {
    data() {
        return {
            video: null,
            canvasElement: null,
            canvas: null,
            loadingMessageText: "🎥 无法打开摄像头串流 (点击此处允许启用摄像头)",
            outputVisiable: false,
            serialCode: null,
            devSets: new Set(),
            token: null,
            api_reset_device: null
        };
    },
    mounted() {
        // Init params
        this.api_reset_device = process.env.VUE_APP_API_BASE_URL + "/admin/reset_device";
        this.video = document.createElement("video");
        this.canvasElement = document.getElementById("canvas");
        this.canvas = this.canvasElement.getContext("2d");
        this.token = getCookiesToken();

        console.log('token === ', this.token);

        this.startVideoStream();
    },
    beforeRouteLeave(to, from, next) {
        this.stopVideoStream();     // 路由切换时关闭摄像头
        next();                     // 继续路由导航
    },
    methods: {
        showPermissionInstructions() {
            this.$confirm(`<p style="font-weight: bold;">您已拒绝摄像头访问权限。请按照以下步骤开启权限：</p>
            <p>1.点击浏览器地址栏左侧的锁定/信息图标</p>
        <p>2.在下拉菜单中找到"摄像头"选项</p>
        <p>3.将设置更改为"允许"</p>
        <p>4.刷新页面</p>`, '需要摄像头权限', {
            confirmButtonText: '已更改设置，刷新页面',
            cancelButtonText: '稍后再说',
            dangerouslyUseHTMLString: true
            }).then(() => {
                window.location.reload()
            }).catch(() => {
                
            });
        },

        matchSerialCode(matchStr) {
            if (!matchStr)
                return null;

            const regex = /serial_code=([0-9a-z]{12})/;
            const match = matchStr.match(regex);
            if (match) {
                console.log("matched string: ", match[1]);  // 捕获组下标1的元素对应设备的序列号
                return match[1];
            } else {
                console.log("un-matched any string!");
                return null;
            }
        },
        checkSerialCode(serialCode) {
            console.log("check if serial_code is correct", serialCode);
            if (!serialCode)
                return null;

            const regex = /[0-9a-z]{12}/;
            const match = serialCode.match(regex);

            if (match && match[0] === serialCode) {
                console.log("serial code is correct", match[0], serialCode);
                return serialCode;
            } else {
                console.error("serial code is not correct!!!", match, serialCode);
                return null;
            }
        },
        async handleResetDevice() {
            var deletedSets = new Set();

            for (const item of this.devSets) {
                try {
                    const checkedSerail = this.checkSerialCode(item);
                    if (checkedSerail) {
                        // only for test, comment
                        // if (checkedSerail === 'be1801008c18')
                        //     throw new Error('test error');
                        // const myHeaders = new Headers();
                        // myHeaders.append("Authorization", "Bearer " + this.token);
                        // console.log('headers', myHeaders);

                        const bodyData = new FormData();
                        bodyData.append("serial_code", checkedSerail);

                        const resetResponse = await fetch(this.api_reset_device, {
                            method: 'POST',
                            // headers: myHeaders,
                            headers: {'Authorization': this.token },
                            // headers: {'Authorization': `Bearer ${this.token}`},
                            body: bodyData
                        });

                        console.log('response', resetResponse);

                        const resetData = await resetResponse.json();
                        if (resetData.code === 200) {
                            this.$message.success('重置成功')
                            console.log('Reset Device data succeed!', checkedSerail);
                            // 列表中移除已经清除数据成功的设备
                            deletedSets.add(checkedSerail);
                        } else {
                            console.error('Reset Device data failed!', resetData);
                            this.$message.error('重置失败')
                        }
                    } else {
                        console.error('check serial code failed!', item, checkedSerail);
                    }
                }
                catch (error) {
                    console.error(error);
                }
                
                // 去除已经清除数据成功的设备
                this.devSets = this.devSets.difference(deletedSets);
            }

        },
        drawLine(begin, end, color) {
            this.canvas.beginPath();
            this.canvas.moveTo(begin.x, begin.y);
            this.canvas.lineTo(end.x, end.y);
            this.canvas.lineWidth = 4;
            this.canvas.strokeStyle = color;
            this.canvas.stroke();
        },
        startVideoStream() {
            var _this = this
            // 使用 facingMode: environment 尝试开启后置摄像头
            if(navigator.mediaDevices) {
                navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
                .then(stream => {
                    this.video.srcObject = stream;
                    this.video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
                    this.video.play();
                    requestAnimationFrame(this.tick);
                    console.log('start video stream...');
                })
                .catch(error => {
                    console.error('Unable to access video stream', error);
                    _this.showPermissionInstructions()
                });
            } else {
                this.$message.error('无法开启摄像头')
            }
            
        },
        tick() {
            if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
                this.loadingMessageText = "";
                this.outputVisiable = true;
                this.canvasElement.hidden = false;

                this.canvasElement.width = this.video.videoWidth;
                this.canvasElement.height = this.video.videoHeight;

                this.canvas.drawImage(this.video, 0, 0, this.canvasElement.width, this.canvasElement.height);

                const imageData = this.canvas.getImageData(0, 0, this.canvasElement.width, this.canvasElement.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height, {
                    inversionAttempts: "dontInvert",
                });

                if (code) {
                    const serialCode = this.matchSerialCode(code.data);
                    if (serialCode) {
                        // this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
                        // this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
                        // this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
                        // this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");

                        this.serialCode = serialCode;
                        // this.devSets.add(serialCode);

                        const found = Array.from(this.devSets).includes(serialCode);
                        if (!found) {
                            if (window.confirm(`请检查序列号是否正确!\n ${serialCode}`)) {
                                this.devSets.add(serialCode);
                            }
                        }
                    }
                } else {
                    this.serialCode = null;
                }
            }

            requestAnimationFrame(this.tick);
        },
        stopVideoStream() {
            // 关闭摄像头
            if (this.video.srcObject) {
                const tracks = this.video.srcObject.getTracks();
                tracks.forEach(track => { track.stop(); });
                this.video.srcObject = null;
                console.log('Video Stream Stopped!');
            } else {
                console.log('Video Stream Already Stopped!');
            }
        }
    }
}
</script>

<style lang="css" scoped>
/* latin-ext */
@font-face {
  font-family: 'Ropa Sans';
  font-style: normal;
  font-weight: 400;
  src: url(../assets/EYqxmaNOzLlWtsZSScy6UzNpcZGf20NE.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Ropa Sans';
  font-style: normal;
  font-weight: 400;
  src: url(../assets/EYqxmaNOzLlWtsZSScy6XTNpcZGf2w.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
body {
    font-family: 'Ropa Sans', sans-serif;
    color: #333;
    max-width: 640px;
    margin: 0 auto;
    position: relative;
}

#githubLink {
    position: absolute;
    right: 0;
    top: 12px;
    color: #2D99FF;
}

h1 {
    margin: 10px 0;
    font-size: 40px;
}

#loadingMessage {
    text-align: center;
    padding: 40px;
    background-color: #eee;
}

#canvas {
    /* width: 100%; */
    width: 640px;
    height: 480px;
}

#output {
    margin-top: 20px;
    background: #eee;
    padding: 10px;
    padding-bottom: 0;
}

#output div {
    padding-bottom: 10px;
    word-wrap: break-word;
}

#noQRFound {
    text-align: center;
}

#container {
    text-align: center;
    font-size: 50px;
    color: red;
}

</style>